/* eslint-disable @typescript-eslint/ban-ts-ignore */
import React, { useContext, useEffect, useState } from "react";

import { ElementState, Preview } from "@creatomate/preview";
// @ts-ignore
import { createSelectable } from "react-selectable";
import styled from "styled-components";

import Element from "./elements/Element";
import ImageElement from "./elements/ImageElement";
import { VIDEO_TYPE } from "../utils/constants";
import { CreatomateContext } from "../contexts/VideoStudioContext";

const Main = styled.div<{ withVideos: boolean }>`
  position: relative;
  margin: 5px 0;
  height: ${props => (props.withVideos ? "75px" : "35px")};
`;

interface TrackProps {
  elements: ElementState[];
  preview: Preview;
}

interface CreatomateElementProps {
  currentElement: ElementState;
  elements: ElementState[];
  preview: Preview;
  withVideos: boolean;
}

const SelectableComponent = createSelectable(Element);
const SelectableImageComponent = createSelectable(ImageElement);

const CreatomateElement: React.FC<CreatomateElementProps> = ({
  currentElement, elements, preview, withVideos
}) => {
  const { data: { mediaType } } = useContext(CreatomateContext);

  if (mediaType === VIDEO_TYPE) {
    return (
      <SelectableComponent
        currentElement={currentElement}
        elements={elements}
        preview={preview}
        selectableKey={currentElement.source.id}
        withVideos={withVideos}
      />
    );
  }

  // it is an image
  return (
    <SelectableImageComponent
      currentElement={currentElement}
      preview={preview}
      selectableKey={currentElement.source.id}
    />
  );
};

const Track: React.FC<TrackProps> = ({ elements, preview }) => {
  const [withVideos, setWithVideos] = useState(false);

  useEffect(
    () => {
      setWithVideos(!!elements.find(element => element.source.type === VIDEO_TYPE));
    }, [elements]
  );

  return (
    <Main withVideos={withVideos}>
      {elements.map(element => (
        <CreatomateElement
          key={element.source.id}
          currentElement={element}
          elements={elements}
          preview={preview}
          withVideos={withVideos}
        />
      ))}
    </Main>
  );
};

export default Track;
